<template>
  <!--<div class="box">-->
    <!--<div class="box-body">-->
      <div class="row">
        <div class="col-md-4 col-sm-12">
          <!--<h5>{{ car.fullText }} <span v-if="car.plate !== ''">{{ car.plate  }} | {{ car.price.toLocaleString() }}€</span><span v-else>{{ car.price.toLocaleString() }} €</span>-->
          <!--</h5>-->
          <h2>{{ car.version.maker.name }} {{ car.version.model.name }}</h2>
          <h5>{{ this.capitalize(car.version.name) }}</h5>
          <div class="row">

            <div class="col-sm-6">
              <img :src="getThumbnail()" class="img-responsive car_thumbnail" alt="Car thumbnail" />
              <small>
                <ul class="ul_horizontal">
                  <li v-if="car.plate !== ''">{{ car.plate }}</li>
                  <li>{{car.price.toLocaleString()}} €</li>
                  <li>{{ car.kilometers.toLocaleString() }} km</li>
                </ul>
              </small>
              <small>Creado el {{ formatDate(car.createdAt) }}</small>
              <small>Publicado el {{ formatDate(car.publicationSort) }}</small>
            </div>

            <div class="col-sm-6" v-if="graphData !== null">
              <ul class="ul_vertical">
                <li>Días publicado: {{ graphData.published }}</li>
                <li>Días no publicado: {{ graphData.unpublished }}</li>
              </ul>
              <!--<radar-chart-component />-->
            </div>
          </div>
        </div>
        <div class="col-md-8 col-sm-12">
          <graph-component :car="this.car" :dates="dates" v-on:graphDataReceived="onGraphDataReceived"></graph-component>
        </div>
      </div>
    <!--</div>-->
  <!--</div>-->
</template>

<script>
import GraphComponent from '@/components/GraphComponent'
import Strings from '@/utils/Strings'
import RadarChartComponent from '@/components/custom/RadarChartComponent'
import moment from 'moment'

export default {
  name: 'CarGraphCellComponent',
  props: ['car', 'dates'],
  components: { GraphComponent, RadarChartComponent },
  data () {
    return {
      graphData: null
    }
  },
  methods: {
    formatDate (date) {
      return moment(date).format(`DD-MM-YYYY HH:mm:ss`)
    },
    getThumbnail () {
      return `${process.env.PICTURE_ENDPOINT}/${this.car.thumbnail}`
    },
    capitalize (str) { return Strings.convertCase(str) },
    onGraphDataReceived (graphData) {
      this.graphData = graphData
    }
  }
}
</script>

<style scoped lang="scss">
  .car_thumbnail {
    border: 1px solid transparent;
    border-radius: 4px;
  }

  ul.ul_horizontal li {
    display: inline-block;
  }

  ul.ul_horizontal {
    list-style: none;
    padding-left: 0;
    -webkit-padding-start: 0;
  }
  ul.ul_horizontal li:not(:first-child):before {
    content: " | ";
    white-space: pre;
  }

  ul.ul_vertical {
    list-style: none;
    padding-left: 0;
    -webkit-padding-start: 0;
  }

  .pic {
    background-color: red;
  }

  .poc {
    background-color: blue;
  }
</style>



// WEBPACK FOOTER //
// src/components/custom/CarGraphCellComponent.vue